import React from 'react'
import './PrivacyPolicy.css' // Import the CSS file

const PrivacyPolicy = () => {
  return (
    <div className='privacy-policy'>
      {' '}
      {/* Add the class name */}
      <h1>Política para el Tratamiento de Datos Personales</h1>
      <p>
        <div className='PrivacyGDPR-section'>
          <div className='row u-row-wrapper'>
            <div className='col-xs-12'>
              <p>
                <strong>
                  SANDRA LOPEZ GONZALEZ, PERSONA FÍSICA CON ACTIVIDAD
                  EMPRESARIAL
                </strong>
                , en adelante Sat Nam Yoga Estudio, en carácter de Responsable
                del tratamiento de los datos personales de los{' '}
                <strong>
                  Usuarios de nacionalidad mexicana o ubicados en los Estados
                  Unidos Mexicanos – en su modalidad de estudiantes - del sitio
                  web www.satnamyogaestudio.com
                </strong>
                , pone a tu disposición el presente Aviso de Privacidad
                Integral, el cual ha sido elaborado en apego a la Ley Federal de
                Protección de Datos Personales en Posesión de los Particulares y
                su regulación secundaria.
              </p>
              <h3>Identificación del Responsable</h3>
              <table>
                <tbody>
                  <tr>
                    <td>Razón Social</td>
                    <td>SANDRA LOPEZ GONZALEZ</td>
                  </tr>
                  <tr>
                    <td>Nombre Comercial</td>
                    <td>Sat Nam Yoga Estudio</td>
                  </tr>
                  <tr>
                    <td>Giro</td>
                    <td>
                      &quot;Servicios de Cursos en Línea&quot; y &quot;Servicios
                      educativos y de enseñanza&quot;{' '}
                    </td>
                  </tr>
                  <tr>
                    <td>Sitio Web</td>
                    <td>
                      <a href='https://satnamyogaestudio.com'>
                        www.satnamyogaestudio.com
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>Teléfono</td>
                    <td>+57 (33) 18124655</td>
                  </tr>
                  <tr>
                    <td>Domicilio</td>
                    <td>
                      Calle Plateros, Número Exterior 2378 , Jardines del
                      Country, Código Postal 44210, Guadalajara, Jalisco,
                      México.
                    </td>
                  </tr>
                  <tr>
                    <td>Correo Electrónico</td>
                    <td>
                      <a href='mailto:satnamyogajal@gmail.com'>
                        satnamyogajal@gmail.com
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>Horario De Atención</td>
                    <td>lunes a viernes de 10-13h</td>
                  </tr>
                </tbody>
              </table>
              <h3>Público al que dirigimos este Aviso de Privacidad</h3>
              <p>
                Este Aviso de Privacidad en tu versión Integral está dirigido a
                nuestros{' '}
                <strong>
                  Estudiantes del sitio web www.satnamyogaestudio.com de
                  nacionalidad mexicana o ubicados en los Estados Unidos
                  Mexicanos.
                </strong>
              </p>
              <h3>Datos Personales</h3>
              <h4>Lista de Datos Personales Sujetos a Tratamiento</h4>
              <p>
                En Sat Nam Yoga Estudio, realizamos el tratamiento de diversas
                categorías de datos personales. Para tu mejor entendimiento, a
                continuación, detallamos cuáles categorías y datos personales
                específicos son las que están bajo nuestro tratamiento:
              </p>
              <table>
                <tbody>
                  <tr>
                    <th>Categoría</th>
                    <th>Dato personal</th>
                  </tr>
                  <tr>
                    <td>Datos de Identificación</td>
                    <td>
                      Domicilio
                      <br />
                      Edad
                      <br />
                      Fecha de nacimiento
                      <br />
                      Fotografía de perfil
                      <br />
                      Género
                      <br />
                      Nombre completo
                      <br />
                      Nombre de usuario de redes sociales (Twitter y/o Facebook)
                      <br />
                      País de procedencia
                      <br />
                      Registro Federal de Contribuyentes
                    </td>
                  </tr>
                  <tr>
                    <td>Datos Académicos</td>
                    <td>
                      Nivel educativo
                      <br />
                      Temas de interés académico
                    </td>
                  </tr>
                  <tr>
                    <td>Datos de Contacto</td>
                    <td>
                      Correo electrónico
                      <br />
                      Teléfono celular
                    </td>
                  </tr>
                  <tr>
                    <td>Datos Financieros (para reembolsos)</td>
                    <td>
                      Número de cuenta bancaria
                      <br />
                      Número CLABE
                    </td>
                  </tr>
                  <tr>
                    <td>Datos de Navegación web</td>
                    <td>
                      Anuncios que visita en nuestro sitio <br />
                      Dirección IP desde la cual nos visita
                      <br />
                      Fecha y hora de tu visita
                      <br />
                      Información del navegador: programa y versión
                      <br />
                      Información que intercambia con nuestro sitio
                      <br />
                      Nombre del dominio de tu proveedor de servicio de Internet
                      <br />
                      Páginas visitadas en nuestro sitio web
                      <br />
                      Tipo de computadora o sistema operativo utilizado
                      <br />
                      Ubicación: ubicación aproximada (según la red) y/o
                      ubicación precisa (según el GPS y la red)
                      <br />
                      Velocidad de tu conexión
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4>Datos Personales Sensibles</h4>
              <p>
                Te informamos que no recabamos ni realizamos el tratamiento de
                datos personales de carácter sensible de nuestros{' '}
                <strong>
                  Estudiantes del sitio web www.satnamyogaestudio.com
                </strong>{' '}
                En caso de que sea requerido un cambio al respecto, haremos de
                tu conocimiento dicha modificación en nuestro Aviso de
                Privacidad Integral.
              </p>
              <h4>¿Cómo obtenemos tus datos personales?</h4>
              <p>
                En forma directa: vía correo electrónico, vía telefónica, a
                través de nuestras redes sociales, a través de mensajería
                instantánea (WhatsApp y/o Facebook Messenger), vía chat en línea
                y a través de nuestros formularios ubicados en nuestro sitio
                web.
              </p>
              <h3>Finalidades del tratamiento de datos personales</h3>
              <p>
                Las finalidades son aquellas que motivan el tratamiento de tus
                datos personales, para tu entendimiento y por disposición de ley
                se clasifican en primarias y secundarias.
              </p>
              <h4>Finalidades primarias</h4>
              <p>
                La finalidad primaria es aquella que es necesaria realizar para
                el desarrollo de una obligación jurídica o el motivo principal
                por el cual existe una relación entre el Titular (tú) y el
                Responsable (nosotros), si te opones a alguna de estas
                finalidades, Sat Nam Yoga Estudio estarás impedido a realizar
                cualquiera de las acciones que señalamos a continuación.
              </p>
              <table>
                <tbody>
                  <tr>
                    <th>Categoría</th>
                    <th>Finalidad</th>
                  </tr>
                  <tr>
                    <td>Prestación de Servicios</td>
                    <td>
                      Activar el plan seleccionado en tu compra
                      <br />
                      Ampliar tu plan de cursos en línea en caso de adquirir un
                      plan superior al que estás suscrito actualmente
                      <br />
                      Crear tu cuenta de usuario
                      <br />
                      Emitir y/o corregir un certificado de participación y
                      aprobación del curso
                      <br />
                      Enviar la confirmación del registro de cuenta de usuario
                      <br />
                      Enviar un resumen de la compra de tu plan
                      <br />
                      Gestionar el traspaso de tu cuenta de usuario (en caso de
                      solicitarlo)
                      <br />
                      Gestionar garantías
                      <br />
                      Gestionar la cancelación de tu cuenta de usuario
                      <br />
                      Gestionar reembolsos de pagos realizados (en caso de
                      aplicar)
                      <br />
                      Identificar el avance de los cursos a los que ingresas
                      <br />
                      Identificar y procesar la compra del plan de su interés
                      <br />
                      Pausar tu plan de cursos en línea en caso de solicitarlo
                      <br />
                      Realizar cambios y actualizaciones a tu cuenta de usuario
                      <br />
                      Realizar un registro de asistentes a nuestras sesiones en
                      vivo
                      <br />
                      Segmentar tu usuario y mejorar tu experiencia dentro de
                      nuestro sitio web y/o aplicación móvil
                    </td>
                  </tr>
                  <tr>
                    <td>Atención a Estudiantes</td>
                    <td>
                      Proporcionar atención con respecto a quejas, sugerencias,
                      comentarios, garantías y reembolsos
                      <br />
                      Proporcionar información sobre nuestros servicios
                    </td>
                  </tr>
                  <tr>
                    <td>Facturación y Cobranza</td>
                    <td>
                      Domiciliar los pagos del plan suscrito (en caso de
                      autorizarlo)
                      <br />
                      Elaborar y enviar comprobantes fiscales de la compra de tu
                      plan
                    </td>
                  </tr>
                  <tr>
                    <td>Soporte Técnico</td>
                    <td>
                      Atender las notificaciones sobre errores, fallos o
                      mantenimiento de nuestro sitio web y/o aplicación móvil
                      <br />
                      Proporcionar soporte técnico de nuestro sitio web y/o
                      aplicación móvil
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4>Finalidades Secundarias</h4>
              <p>
                La finalidad secundaria es aquella que no es necesaria para el
                desarrollo de una relación jurídica entre el Titular (tu) y el
                Responsable (nosotros), por lo cual puedes indicarnos que no
                autorizas el tratamiento de tus datos personales en alguna o
                todas las finalidades que se mencionan a continuación:
              </p>
              <table>
                <tbody>
                  <tr>
                    <th>Categoría</th>
                    <th>Finalidad</th>
                  </tr>
                  <tr>
                    <td>Mercadotecnia</td>
                    <td>
                      Contactarte para prospectar la compra de un plan superior
                      al que estás suscrito actualmente o renovar tu plan
                      próximo a vencer
                      <br />
                      Elaborar perfiles de clientes conforme a los temas de
                      interés seleccionados en tu perfil de usuario
                      <br />
                      Enviar información sobre nuevos cursos y agenda de
                      sesiones en vivo
                      <br />
                      Enviar publicidad de nuestros servicios
                      <br />
                      Publicar tus comentarios e historias de éxito derivado del
                      uso de nuestros servicios
                      <br />
                      Publicar tus comentarios sobre nuestros cursos en nuestras
                      redes sociales oficiales
                      <br />
                      Realizar estadísticas de uso
                      <br />
                      Realizar estudios de mercado
                    </td>
                  </tr>
                  <tr>
                    <td>Encuestas</td>
                    <td>
                      Enviar encuestas de satisfacción de nuestros servicios
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3>
                Mecanismo para manifestar tu no aceptación a las finalidades
                secundarias
              </h3>
              <p>
                En cualquier momento, puedes hacer uso del ejercicio de tu
                Derecho de Oposición a las finalidades secundarias que señalamos
                en este Aviso de Privacidad, para saber cómo hacerlo consulta el
                procedimiento establecido en la sección “Derechos de Acceso,
                Rectificación, Cancelación y Oposición (ARCO)”
              </p>
              <h3>Transferencias de datos personales</h3>
              <p>
                No realizamos transferencia nacional ni internacional de tus
                datos personales a terceros, sin embargo, es importante que
                sepas que los datos personales de los cuales realizamos los
                tratamientos mencionados están alojados en servidores de
                almacenamiento y procesamiento fuera de los Estados Unidos
                Mexicanos.
              </p>
              <h3>
                Derechos de Acceso, Rectificación, Cancelación y Oposición
                (ARCO)
              </h3>
              <h4>¿Qué son los derechos ARCO?</h4>
              <p>
                Los Derechos ARCO son el mecanismo legal que te permiten ejercer
                tus Derechos de Acceso, Rectificación, Cancelación y Oposición,
                los cuales consisten en:
              </p>
              <ul>
                <li>
                  Acceder a los datos personales, exclusivamente a los tuyos,
                  salvo que seas representante legal o tutor de otro titular y
                  que se encuentran bajo nuestro tratamiento
                </li>
                <li>
                  Solicitar que realicemos correcciones o actualizaciones de tus
                  datos personales
                </li>
                <li>
                  Solicitar que eliminemos tus datos personales, cuando esto sea
                  legalmente procedente
                </li>
                <li>
                  Oponerte a la realización de las finalidades primarias
                  establecidas en este Aviso de Privacidad – supuesto bajo el
                  cual, en algunos casos, no podremos realizar cualquiera de las
                  acciones que señalamos dentro de esas finalidades
                </li>
                <li>
                  Solicitar tu oposición a la realización de las finalidades
                  secundarias indicadas
                </li>
                <li>
                  Solicitar que tus datos personales no sean transferidos a
                  terceros
                </li>
              </ul>
              <h4>Medios y Procedimiento para ejercer los Derechos ARCO</h4>
              <p>
                Para que tu ejerza cualesquiera de tus derechos ARCO, deberás
                realizarlo en forma personal de acuerdo con el procedimiento que
                se detalla en esta sección.
              </p>
              <p>
                El titular de los datos personales deberás presentar un escrito
                libre en Avenida Paseo de la Reforma, Número Exterior 373,
                Número Interior Piso 20, Alcaldía Cuauhtémoc, Código Postal
                06500, Ciudad de México, México, en un horario de atención de
                lunes a viernes de 10 a 13 h, o bien enviarlo vía correo
                electrónico a la dirección
                <a href='mailto:satnamyogajal@gmail.com'>
                  satnamyogajal@gmail.com
                </a>
                , tu escrito libre deberás incluir como mínimo los siguientes
                datos:
              </p>
              <ul>
                <li>Nombre completo del titular de los datos personales</li>
                <li>
                  Formas de contactarte y comunicarte la respuesta, ya sea
                  cualquiera de los siguientes:
                  <ul>
                    <li>Dirección para recibir mensajería de SEPOMEX</li>
                    <li>Número de teléfono particular</li>
                    <li>Número de teléfono celular</li>
                    <li>Dirección de correo electrónico</li>
                  </ul>
                </li>
                <li>
                  Mención clara y precisa del derecho que buscas ejercer,
                  debiendo señalar solo uno en tu solicitud
                </li>
                <li>
                  Identificación oficial vigente, la cual deberás de presentarse
                  en original y copia para tu cotejo. Si tu solicitud es enviada
                  por vía electrónica, deberás adjuntar tu identificación
                  escaneada donde aparezca tu foto, nombre completo, número de
                  identificación y firma
                </li>
                <li>
                  En caso de no ser el titular de los datos personales deberás
                  adjuntar el documento que te acredite como representante legal
                  (Carta Poder ante Fedatario Público o Acta de Nacimiento en
                  caso de tratarse de menores de edad representados por madre,
                  padre o tutor)
                </li>
                <li>
                  En caso de solicitar cambios derivados de correcciones o
                  actualizaciones, deberás presentar el documento legal que
                  acredite este hecho
                </li>
                <li>
                  Información adicional y precisa que nos facilite la búsqueda
                  de los datos solicitados, señalando - en medida de lo posible
                  - aquellos que nos hayas proporcionado y/o el periodo en el
                  que eso ocurrió
                </li>
                <li>
                  Firma autógrafa, la cual deberá coincidir con la
                  identificación oficial que presentes para realizar el trámite.
                </li>
              </ul>
              <p>
                En un plazo no mayor a 5 días hábiles siguientes a recibir tu
                solicitud, en caso de que exista una duda o requiramos más
                información sobre tu solicitud, te contactaremos a efecto de
                comunicarte dicha situación y obtener más información de tu
                parte respecto a la solicitud. La respuesta a nuestra solicitud
                deberás hacerla en un plazo que no deberás exceder de 10 días
                hábiles.
              </p>
              <p>
                En un plazo no mayor a 20 días hábiles siguientes a recibir tu
                solicitud, o posteriores a haber respondido las aclaraciones
                solicitadas por nuestra parte, te contactaremos a efecto de
                comunicarte la respuesta a tu solicitud, esta respuesta será
                entregada de manera personal en nuestro domicilio, previa
                acreditación del titular o de tu representante, o en tu caso en
                el correo electrónico señalado en tu solicitud original.
              </p>
              <p>
                Para más información acerca de este Aviso de Privacidad o
                cualquier duda sobre como ejercer tus Derechos de Acceso,
                Revocación, Cancelación y Oposición (ARCO), limitar el uso o
                Revocar tu consentimiento, deberás enviar un correo electrónico
                a:{' '}
                <a href='mailto:satnamyogajal@gmail.com'>
                  satnamyogajal@gmail.com
                </a>
                , con el asunto “Información de Derechos ARCO” o bien enviar un
                mensaje vía WhatsApp al número telefónico: +57 (316) 6126223 en
                los días y horarios de atención previamente mencionados.
              </p>
              <h3>Consentimiento</h3>
              <p>
                Te informamos que no recabamos ni tratamos datos personales de
                carácter sensible de nuestros Estudiantes del sitio web
                www.satnamyogaestudio.com por lo que no es necesario que
                manifiestes tu consentimiento de manera expresa en este
                documento para el tratamiento de tus datos personales, sin
                embargo si te solicitaremos que al momento de crear tu cuenta de
                usuario o llenar nuestros formularios selecciones la casilla
                respecto a que has leído y entiendes el alcance de qué datos
                personales recabamos, qué hacemos con ellos y que estás de
                acuerdo con las finalidades primarias y secundarias señaladas.
              </p>
              <p>
                Salvo que ejerzas alguno de tus Derechos de Acceso,
                Rectificación, Cancelación u Oposición (ARCO), limites el uso o
                revoques el consentimiento al tratamiento de tus datos
                personales, consideramos que aceptas lo establecido en el
                presente Aviso de Privacidad Integral.
              </p>
              <h4>
                Mecanismo para revocar el consentimiento otorgado para el
                tratamiento de tus datos personales
              </h4>
              <p>
                En caso de que quieras revocar el consentimiento al tratamiento
                de tus datos personales, deberás realizar el mismo procedimiento
                que está establecido en la sección “Derechos de Acceso,
                Rectificación, Cancelación y Oposición (ARCO)”, tu solicitud
                quedará sujeta a la revisión de esta por nuestro Departamento de
                Protección de Datos Personales; en caso de que no se cumpla con
                una excepción de ley o no exista alguna disposición jurídica que
                nos obligue a realizar el tratamiento de tus datos personales,
                tu solicitud será procedente y te será comunicada la decisión en
                un término de 10 días hábiles.
              </p>
              <h3>Limitación para uso y divulgación de datos personales</h3>
              <p>
                Para el caso de nuestros{' '}
                <strong>
                  Estudiantes del sitio web www.satnamyogaestudio.com
                </strong>
                , en cualquier momento tienen la opción de limitar el uso y/o
                divulgación de datos personales presentando un escrito libre (en
                el domicilio indicado anteriormente o vía correo electrónico al
                email satnamyogajal@gmail.com) y dirigida al Departamento de
                Protección de Datos Personales señalando en tu solicitud el
                alcance de la limitación al uso o divulgación que quieres
                establecer, acompañado de una copia simple de tu identificación
                oficial y debiendo presentarla en original al momento de
                presentar tu escrito. tu solicitud quedará sujeta a revisión por
                nuestro Departamento de Protección de Datos Personales; en caso
                de que no se cumpla con una excepción de ley o no exista alguna
                disposición jurídica que nos obligue a realizar el tratamiento
                de tus datos personales, tu solicitud será procedente y te será
                comunicada la decisión en un término de 10 días hábiles.
              </p>
              <h4>Para temas Comerciales</h4>
              <p>
                Visita el sitio web de la Procuraduría Federal de Consumidor en
                donde está a tu disposición el Registro Público de Consumidores
                (RPC) previsto en la Ley Federal de Protección al Consumidor,
                ahí tu decidirás sobre el uso de tus datos personales en el
                sector comercial, turístico y de telecomunicaciones.
              </p>
              <h4>Para Temas Financieros</h4>
              <p>
                Visita el sitio web de la Comisión Nacional para la Protección y
                Defensa de los Usuarios de Servicios Financieros en donde está a
                tu disposición el Registro Público de Usuarios (REUS) previsto
                en la Ley de Protección y Defensa al Usuario de Servicios
                Financieros, donde tu decidirás sobre el uso de tus datos
                personales en el sector financiero.
              </p>
              <h3>Autoridad Competente</h3>
              <p>
                Tras haber ejercido tus Derechos de Acceso, Rectificación,
                Cancelación u Oposición; Haber limitado el uso o divulgación de
                tus datos personales, o Haber revocado tu consentimiento al uso
                de tus datos personales, sí tu consideras que hemos realizado
                alguna omisión o alguna acción violatoria a lo establecido en la
                Ley Federal de Protección de Datos Personales en Posesión de los
                Particulares, te informamos que la autoridad mexicana competente
                ante la cual deberás interponer tu denuncia o inconformidad es
                el Instituto Nacional de Transparencia, Acceso a la Información
                y Protección de Datos Personales (INAI).
              </p>
              <h3>Uso de Cookies, Web Beacons u otras tecnologías similares</h3>
              <p>
                En nuestro sitio web oficial mx.satnamyogaestudio.com y sus
                subdominios, sí recabamos cookies y sí recabamos web beacons,
                esta información nos permite conocer:
              </p>
              <ul>
                <li>
                  Anuncios que visitas en nuestra plataforma (en forma anónima)
                </li>
                <li>
                  Dirección IP desde la cual nos visitas (en forma anónima)
                </li>
                <li>Fecha y hora de tu visita (en forma anónima)</li>
                <li>
                  Información del navegador: programa y versión (en forma
                  anónima)
                </li>
                <li>
                  Información que intercambias con nuestra plataforma (en forma
                  anónima)
                </li>
                <li>
                  Nombre del dominio de tu proveedor de servicio de Internet (en
                  forma anónima)
                </li>
                <li>
                  Páginas visitadas en nuestra plataforma (en forma anónima)
                </li>
                <li>
                  Tipo de computadora o sistema operativo utilizado (en forma
                  anónima)
                </li>
                <li>
                  Ubicación: ubicación aproximada (según la red) y/o ubicación
                  precisa (según el GPS y la red) (en forma anónima)
                </li>
                <li>Velocidad de tu conexión (en forma anónima)</li>
              </ul>
              <p>
                En general, tu ubicación y tu actividad dentro de nuestra
                plataforma, para optimizar la búsqueda de tus servicios
                preferidos dentro de nuestro sitio web y/o aplicación móvil.
              </p>
              <p>
                Para oponerte a que recabemos estos datos sobre tu visita, te
                recomendamos consultar las guías de configuración de privacidad
                del navegador que utilizas.
              </p>
              <p>
                En caso de iniciar sesión a través de tus redes sociales
                (Twitter o Facebook), te informamos que tenemos acceso a la
                siguiente información:
              </p>
              <ul>
                <p>Twitter</p>
                <li>
                  Información de tu perfil y la configuración de tu cuenta
                </li>
                <li>Cuentas que sigues, silencias y bloqueas</li>
                <li>
                  Tweets de tu cronología (incluidos los protegidos), así como
                  tus listas y colecciones
                </li>
              </ul>
              <ul>
                <p>Facebook</p>
                <li>Nombre registrado en tu cuenta de usuario</li>
                <li>Foto de perfil</li>
                <li>Correo electrónico registrado en tu cuenta de usuario</li>
              </ul>
              <p>
                Para oponerte a que nuestra aplicación móvil tenga acceso a la
                información indicada, te recomendamos consultar las guías de
                configuración de privacidad de tu dispositivo móvil.
              </p>
              <h3>Actualizaciones</h3>
              <p>
                Este Aviso de Privacidad Integral será actualizado en tiempo
                futuro derivado de modificaciones al marco jurídico en materia
                de protección de datos personales en México, cambios en el
                modelo de negocio en Sat Nam Yoga Estudio, nuevos datos
                personales que se recaben y/o cambios en las finalidades. Las
                actualizaciones y modificaciones que se realicen al presente
                Aviso de Privacidad Integral se harán de tu conocimiento a
                través de una comunicación al correo electrónico que nos
                proporcionaste durante el proceso de registro y a través de
                nuestro sitio web oficial:{' '}
                <a href='https://satnamyogaestudio.com'>
                  www.satnamyogaestudio.com
                </a>
                .
              </p>
              <p>
                <strong>Fecha de última actualización:</strong> 27 de febrero de
                2024.
              </p>
            </div>
          </div>
        </div>
      </p>
    </div>
  )
}

export default PrivacyPolicy
